module.exports = __webpack_public_path__ + "img/OM.9584a469.svg";